import React, { useEffect, useState } from "react";
import { Col, FloatingLabel, Form, Modal, Row } from "react-bootstrap";
import { IoArrowForward, IoCloseCircleOutline } from "react-icons/io5";
import * as s from "./index.module.scss";
import CustomerService from "../../../images/FreeAppraisal/customer-service.svg";
import secondaryFont from "@/utils/secondaryFont";
import axios from "axios";
import { useCfStore } from "@/components/CfTurnstile";
import OfferForm from "./OfferForm";
import AppraisalForm from "./AppraisalForm";

const Popups = ({ show, onHide, offer = false, page }) => {
  return (
    <section className={` ${s.modals}`}>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h4 className={` text-center heading fw-bold`}>
            {offer ? "Get a loan offer now" : "Get an offer now"}
          </h4>
          <h6 className={`${secondaryFont} text-center sub-title fw-normal`}>
            {offer
              ? "Need a Collateral Loan? Send us an inquiry or speak with an expert"
              : "You will get the best value for your item and instant cash with us. Send us the details and we will get in touch with you right away."}
          </h6>
          {offer ? <OfferForm page={page} /> : <AppraisalForm page={page} />}
          <div className={s.close_button}>
            <button onClick={onHide}>
              <IoCloseCircleOutline size="48px" />
            </button>
          </div>
          <a href="tel:(212) 913-9141" className={`${s.speak_with_expert}`}>
            <div>
              <img
                loading="lazy"
                src={CustomerService.src}
                alt="image"
                height="100%"
              />
            </div>
            <div>
              <p>
                Speak with an
                <span> expert</span>
              </p>
              <div>
                <span href="tel:(212) 913-9141">(212) 913-9141</span>
              </div>
            </div>
          </a>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Popups;
